import Image from "next/image";

const BoardingPassAccordion = () => {
  return (
    <Image
      style={{
        width: "100%",
        height: "100%",
      }}
      alt="ticket"
      src="/images/boarding-pass.png"
      width={720}
      height={287}
    />
  );
};

export default BoardingPassAccordion;
